'use client';
import { StyledCertificate } from '@/components/common/ygen/sections/certificate/certificate.style.list';
import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination } from 'swiper/modules';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import Prev from '@/components/common/ui/buttons/Prev';
import Next from '@/components/common/ui/buttons/Next';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll';
import CertificateSingle from '@/components/common/ui/single-item/CertificateSingle';

const Certificate = ({ data, version, id }) => {
	const offset = useContainerOffset('.container');

	// Memoize the subtitle to prevent unnecessary re-renders
	const subtitle = useMemo(() =>
			data?.section_data?.subtitle,
		[data?.section_data?.subtitle]
	);

	// Memoize the short description to prevent unnecessary re-renders
	const shortDesc = useMemo(() =>
			data?.section_data?.short_desc,
		[data?.section_data?.short_desc]
	);

	// Memoize the posts list to prevent unnecessary re-renders
	const posts = useMemo(() =>
			data?.posts?.list || [],
		[data?.posts?.list]
	);

	// Memoize the container style to prevent unnecessary re-renders
	const containerStyle = useMemo(() => ({
		paddingLeft: offset + 15
	}), [offset]);

	// Memoize the swiper breakpoints to prevent unnecessary re-renders
	const swiperBreakpoints = useMemo(() => ({
		320: {
			slidesPerView: 1.2,
			spaceBetween: 30,
			mousewheel: false,
			navigation: {
				prevEl: version === 2 ? '#case-study-prev' : '#industry-prev',
				nextEl: version === 2 ? '#case-study-next' : '#industry-next',
			},
		},
		768: {
			slidesPerView: 3.5,
			spaceBetween: 30,
		},
		1024: {
			slidesPerView: 4.2,
			spaceBetween: 30,
		},
	}), [version]);

	return (
		<StyledCertificate
			data-scroll-section
			id={id || 'okay-hero'}
			offset={offset}
			className={`${version === 2 ? 'version_two' : ''} industry_footprintss`}
		>
			<div className={`industry-container ${version === 2 ? 'industry-container-scroll' : ''}`}>
				<RightSVGScroll />
				<Container>
					<Row className="mb80">
						<Col md={4}>
							{subtitle && (
								<p className="subtitle-ygen fade-up">
									{subtitle}
								</p>
							)}
						</Col>
						<Col md={8}>
							{shortDesc && (
								<Title
									tag="h2"
									animClass="fade-up"
									text={shortDesc}
									color="#fff"
								/>
							)}
							<div className="d-flex navigation-item">
								<Prev id={version === 2 ? 'case-study-prev' : 'industry-prev'} />
								<Next id={version === 2 ? 'case-study-next' : 'industry-next'} />
							</div>
						</Col>
					</Row>
				</Container>

				{posts.length > 0 && (
					<Container fluid style={containerStyle}>
						<Row>
							<Col md={12}>
								<Swiper
									slidesPerView={version === 2 ? 4 : 4.2}
									spaceBetween={30}
									slidesPerGroup={4}
									loop={false}
									autoplay={false}
									speed={1500}
									pagination={false}
									navigation={{
										prevEl: version === 2 ? '#case-study-prev' : '#industry-prev',
										nextEl: version === 2 ? '#case-study-prev' : '#industry-next',
									}}
									breakpoints={swiperBreakpoints}
									modules={[Mousewheel, Pagination]}
									className="about-slider_mask w-slider-mask"
								>
									{posts.map((e, index) => (
										<SwiperSlide key={index}>
											<CertificateSingle
												hover="#152637"
												noPara
												subColor="rgba(255,255,255,0.5)"
												color="white"
												imageList={e?.images}
												img={e?.images?.[0]?.full_path}
												title={e?.data?.title}
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</Col>
						</Row>
					</Container>
				)}
			</div>
		</StyledCertificate>
	);
};



export default React.memo(Certificate);
